import { render, staticRenderFns } from "./WebSiteWonderfulList.vue?vue&type=template&id=13d827b0&scoped=true"
import script from "./WebSiteWonderfulList.vue?vue&type=script&lang=js"
export * from "./WebSiteWonderfulList.vue?vue&type=script&lang=js"
import style0 from "./WebSiteWonderfulList.vue?vue&type=style&index=0&id=13d827b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d827b0",
  null
  
)

export default component.exports